import { render, staticRenderFns } from "./MaterialOrderTracking.vue?vue&type=template&id=05f1c81c&scoped=true"
import script from "./MaterialOrderTracking.vue?vue&type=script&lang=js"
export * from "./MaterialOrderTracking.vue?vue&type=script&lang=js"
import style0 from "./MaterialOrderTracking.vue?vue&type=style&index=0&id=05f1c81c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f1c81c",
  null
  
)

export default component.exports